import React, { FC } from 'react';
import Form from 'components/Form';

import { FinishPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Finish: FC<FinishPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Finish;
